import { useCallback } from "react";

import { trackingImplementation } from "@/features/chat/infrastructure/services/trackingImplementation";
import type {
  ChatConversationTrackingEvent,
  ChatListTrackingEvent
} from "@/features/chat/infrastructure/services/tracking";

export const useChatListTracking = () => {
  const track = useCallback((event: ChatListTrackingEvent) => {
    const { name, ...properties } = event;
    trackingImplementation.track(
      name,
      Object.keys(properties).length ? properties : undefined
    );
  }, []);

  return { track };
};

export const useChatConversationTracking = () => {
  const trackPageView = useCallback(() => {
    trackingImplementation.page_view("creator_page_chat_conversation");
  }, []);

  const track = useCallback((event: ChatConversationTrackingEvent) => {
    const { name, ...properties } = event;
    trackingImplementation.track(name, properties);
  }, []);

  return { trackPageView, track };
};

export const useChatUserInfoTracking = () => {
  const trackPageView = useCallback(() => {
    trackingImplementation.page_view("creator_page_chat_user_info");
  }, []);

  return { trackPageView };
};

export const useChatPrivateMediaConfigurationTracking = () => {
  const trackPageView = useCallback(() => {
    trackingImplementation.page_view(
      "creator_page_chat_private_media_configuration"
    );
  }, []);

  return { trackPageView };
};

export const useChatPrivateMediaMymCloudTracking = () => {
  const trackPageView = useCallback(() => {
    trackingImplementation.page_view(
      "creator_page_chat_private_media_mym_cloud"
    );
  }, []);

  return { trackPageView };
};

export const useChatPrivateMediaCollectionTracking = () => {
  const trackPageView = useCallback(() => {
    trackingImplementation.page_view(
      "creator_page_chat_private_media_collection"
    );
  }, []);

  return { trackPageView };
};
